// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__b52gX","modalFooterButton":"ModalNotes_modalFooterButton__1qbQG"};